<template>
  <v-form v-model="valid" ref="mainForm">
    <CaseACocherLive code="demission_confirmation" v-model="sasDemission.confirmation" :live="liveSasDemission(8105)" />
    <CatalogueLive code="demission_motif" v-model="sasDemission.motifDeDemission" :live="liveSasDemission(8103)" />
    <TextFieldLive
      code="demission_autre_motif"
      v-model="sasDemission.autreMotif"
      :live="liveSasDemission(8104)"
      :opq-if="estAutre(sasDemission.motifDeDemission)"
    />
    <DatePickerLive
      code="demission_date"
      v-model="sasDemission.dateDeDemissionSouhaitee"
      :live="liveSasDemission(8102)"
      :minValue="serverDateBefore22h00()"
      :maxValue="convertStrDateToString(sas.dateDemissionMax)"
    />
  </v-form>
</template>


<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasDemission() {
      return this.sas.sasDemission
    }
  },
  methods: {
    liveSasDemission(cle) {
      return { endpoint: "sas-demission", cle: cle, fileId: this.sasDemission.id }
    },
    estAutre(motifDeDemission) {
      return this.getCatalogueCodeById("11139", motifDeDemission) == "00"
    }
  }
}
</script>

<style>
</style>